import React, { useEffect } from "react"
import { RouteComponentProps } from "react-router"
import CalendarEventCreate from "../components/CalendarEventCreateComponent"
import { FormattedMessage } from "react-intl"
import SideBar from "../../common/layout/sidebar.component"

type RouteProps = {
    contactId?: string,
}

const CalendarEventPage = (props: RouteComponentProps<object, never, RouteProps>) => {
    
    useEffect(() => {
        SideBar.activateMenu("schedulingpage")
    }, [])

    let contactId = ""
    if (props.location && props.location.state && props.location.state.contactId) {
        contactId = props.location.state.contactId
    }


    return (
        <div className="calendar-event-page col-12 ui-module mb-3">
            <h3 className="mb-3">
                <FormattedMessage
                    id="calendar.new_event.header"
                    defaultMessage="Create new event"
                />
            </h3>
            <CalendarEventCreate
                providedContactId={contactId} />
        </div>
    )
}

export default CalendarEventPage


// WEBPACK FOOTER //
// ./src/calendar/pages/CalendarEventPage.tsx